import { enableProdMode, StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ServerConfiguration } from '@services/configuration.service';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers: StaticProvider[] = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

fetch('/api/configuration').then(async res => {
  providers.push({
    provide: ServerConfiguration,
    useValue: await res.json()
  });
}).catch(() => {
  providers.push({
    provide: ServerConfiguration,
    useValue: {
      apiUrl: 'https://localhost:44331/api',
      releaseVersion: 'dev',
      microsoftOAuthClientId: '',
      microsoftOAuthRedirectUrl: 'https://localhost:4200/oauth',
      microsoftOAuthAuthority: 'https://login.microsoftonline.com/common',
    },
  });
  console.warn("Could not retrieve config from .net core controller. \n Using default values for API/IDP urls in configuration.service.ts.")
}).finally(() => {
  platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch(err => console.error(err));
})
